import eBillHomeApi from '@/api/eBillHome/eBillHomeApi.js';

export default {
	name: 'e-bill-apply3',
	mixins: [],
	extends: {},
	components: {},
	props: ['applyOption', 'applyText', 'email', 'notifyMdn'],
	data() {
		return {
			profile: this.$store.state.profile,
		};
	},
	computed: {

	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {

		init() {
			if (!this.email && !this.notifyMdn) {
				this.$router.push({ name: 'e-bill-apply2' });
			}
		},

		async applyMailConfirm() {
			let result;
			if (this.applyOption == 'eBill') {
				result = await eBillHomeApi.changeEBillType(this.profile.mdn, "1", this.email, this.notifyMdn);
			} else if (this.applyOption == 'SMS') {
				result = await eBillHomeApi.changeEBillType(this.profile.mdn, "2", '', this.notifyMdn);
			}
			if (result) {
				this.$router.push({ name: 'e-bill-apply-result' });
				return;
			}

		}

	},
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBillApply/eBillApply3.js